import React, { Component } from 'react'
import Modal from 'react-bootstrap/Modal'

class modal extends Component {
    // El contenido pesado (formularios con muchos catálogos) se monta hasta que termina la animación de apertura:
    // así el modal aparece y responde (scroll) de inmediato en vez de quedarse "trabado" durante el primer render.
    state = { entered: false }

    componentDidUpdate(prevProps){
        if (prevProps.show && !this.props.show && this.state.entered) this.setState({ entered: false })
        var elementos = document.getElementsByClassName('modal');
        for(let cont = 0; cont < elementos.length; cont ++){
            elementos[cont].removeAttribute("tabindex")
        }
    }

    restorePageScroll = () => {
        window.requestAnimationFrame(() => {
            if (document.querySelector('.modal.show')) return

            document.body.classList.remove('modal-open')
            document.body.style.overflow = ''
            document.body.style.paddingRight = ''
            document.documentElement.style.overflow = ''
        })
    }

    render() {
        const { show, handleClose, children, title, size, icon, customcontent, contentcss, classBody, bgHeader, dialogClassName } = this.props

        return (
            <>
               <Modal
                    show={show}
                    size={size}
                    onHide={handleClose}
                    keyboard={true}
                    centered={!customcontent}
                    contentClassName={contentcss}
                    dialogClassName={dialogClassName}
                    backdrop="static"
                    onEntered={() => this.setState({ entered: true })}
                    onExited={this.restorePageScroll}
                    >
                    <Modal.Header className={bgHeader}>
                        <h5 className="modal-title" id="exampleModalLabel">
                        {title}
                        {icon && <i className={`${icon}`}></i>}
                        </h5>
                        <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={handleClose}
                        >
                        <i aria-hidden="true" className="ki ki-close"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body
                        style={{
                        paddingTop: "0px",
                        maxHeight: "70vh", // Limita la altura del contenido
                        overflowY: "auto", // Habilita el scroll vertical si el contenido excede la altura
                        }}
                        className={classBody}
                    >
                        {(this.state.entered || this.props.sinDiferir) ? children : (
                            <div style={{ minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontSize: 13 }}>
                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span> Cargando…
                            </div>
                        )}
                    </Modal.Body>
                </Modal>

            </>
        )
    }
}

export default modal
